import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import {
  useGlobalStore,
  GlobalContext,
  ModalContext,
} from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { useNavigate } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { nlPost } from '../../apis/notLoginApi';

import { NumericFormat } from 'react-number-format';
import { error, param } from 'jquery';

const UserInfo = () => {
  useEffect(() => {
    document.title = '사용자 정보';
  }, []);

  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const { store } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const [searchMethod, setSearchMethod] = useState('entNm'); // 검색 방법
  const [searchValue, setSearchValue] = useState(''); // 검색 값

  const [entData, setEntData] = useState([]);

  const [formData, setFormData] = useState({
    userSn: '',
    userId: '',
    userNm: '',
    userTelno: '',
    userMblTelnl: '',
    userEml: '',
    userType: 'U',
    entSn: '',
  });

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        userId: store.userId || '',
      }));
    }
  }, [store]);

  useEffect(() => {
    if (formData.userId) {
      getUserInfo();
    }
  }, [formData.userId]);

  const getUserInfo = () => {
    const url = '/member/getUserInfo.do';
    const param = {
      userId: formData.userId.replace(/\s+/g, ''),
      userType: formData.userType,
    };
    dbPost(url, param)
      .then(response => {
        setFormData(prevFormData => ({
          ...prevFormData,
          userSn: response.userSn || '',
          userNm: response.userNm || '',
          userTelno: response.userTelno || '',
          userMblTelno: response.userMblTelno || '',
          userEml: response.userEml || '',
          picDept: response.picDept || '',
          wrkrRole: response.wrkrRole || '',
          entNm: response.entNm || '',
          entSn: response.entSn || '',
        }));
      })
      .catch(error => {});
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  const closeModal = () => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
  };

  const searchEnt = () => {
    param = {
      entNm: searchValue,
      searchMethod: searchMethod,
    };
    const url = '/member/entList.do';
    nlPost(url, param)
      .then(response => {
        setEntData(response);
      })
      .catch(error => {});
  };

  const entSelect = entSn => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
    const selectedEnt = entData.find(ent => ent.entSn === entSn);
    if (selectedEnt) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entNm: selectedEnt.entNm,
        entSn: selectedEnt.entSn,
        brno: selectedEnt.brno,
      }));
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showModal]);

  const [placeHolderMsg, setPlaceHolderMsg] = useState('기업명을 검색해주세요');

  const handleSearchMethodChange = e => {
    setSearchMethod(e.target.value);
  };

  useEffect(() => {
    if (searchMethod === 'entNm') {
      setPlaceHolderMsg('기업명을 검색해주세요');
    } else if (searchMethod === 'brno') {
      setPlaceHolderMsg('사업자등록번호를 검색해주세요');
    }
  }, [searchMethod]);

  const beforeUpdate = async () => {
    const validationRules = {
      userId: { presence: true },
      userNm: { presence: true },
      userTelno: { presence: true },
      userMblTelno: { presence: true },
      entNm: { presence: true },
      entSn: { presence: true },
      userEml: { presence: true, email: true },
      picDept: { presence: true },
      wrkrRole: { presence: true },
    };

    const altKey = {
      userId: '아이디',
      userNm: '이름',
      userTelno: '전화번호',
      userMblTelno: '휴대전화',
      entNm: '기업명',
      entSn: '기업 번호',
      userEml: '이메일',
      picDept: '부서',
      wrkrRole: '직책',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }
    updateUserInfo();
  };

  const updateUserInfo = () => {
    const url = '/member/updateUserInfo.do';
    const param = {
      userNm: formData.userNm,
      userSn: formData.userSn,
      userId: formData.userId,
      userTelno: formData.userTelno,
      userMblTelno: formData.userMblTelno,
      userEml: formData.userEml,
      picDept: formData.picDept,
      wrkrRole: formData.wrkrRole,
      entSn: formData.entSn,
      userType: formData.userType,
    };

    if (param.userId != '' && param.userType != '') {
      dbPost(url, param)
        .then(response => {
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == true) {
            } else if (response == false) {
            }
          }
          modalService.successAlert('변경사항이 적용되었습니다.', () => {
            navigate('/');
          });
        })
        .catch(error => {});
    }
  };

  const withDrawal = () => {
    navigate('/member/userInfo/userWithdrawal');
  };

  const openModal = () => {
    searchEnt();
    setShowModal(true);
  };

  const handleInputChangeName = e => {
    const { id, value } = e.target;
    // 숫자가 포함되지 않은 경우에만 상태를 업데이트
    if (!/\d/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
  };

  return (
    <>
      {/* <button onClick={updateUserInfo}>updateUserInfo</button> */}
      <div>
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">사용자 정보</h2>
        </div>
        <h3 className="content-tit">사용자 정보</h3>
        <p className="text-gray-70">
          사용자 정보를 확인하고 수정하실 수 있습니다.
        </p>
        <p className="tbl-msg gap-sm">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <div className="txt-box bg-white">
          <h4>사용자 정보</h4>
          <fieldset>
            <legend>사용자 정보 입력</legend>
            <div className="fieldset">
              <div className="form-group">
                <div className="form-title">
                  <label>
                    아이디<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts" style={{ width: '64.4%' }}>
                  <div className="input-group">
                    <div className="box-sec">
                      <h5 className="box-tit2">
                        <label>{formData.userId || ''}</label>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="userNm">
                    이름<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts" style={{ width: '64.4%' }}>
                  <input
                    type="text"
                    id="userNm"
                    value={formData.userNm || ''}
                    onChange={handleInputChangeName}
                    className="form-control"
                    maxLength={20}
                    aria-labelledby="userNm"
                  />
                </div>
              </div>
              <div className="input-group">
                <div className="form-group">
                  <div className="form-title">
                    <label htmlFor="userTelno">
                      전화번호<em className="star-require">*</em>
                    </label>
                  </div>
                  <div className="form-conts">
                    <NumericFormat
                      type="text"
                      id="userTelno"
                      className="form-control"
                      value={formData.userTelno || ''}
                      onChange={handleInputChange}
                      thousandSeparator={false}
                      maxLength={11}
                      allowLeadingZeros={true}
                      allowNegative={false}
                      aria-labelledby="userTelno"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-title">
                    <label htmlFor="userMblTelno">
                      휴대전화<em className="star-require">*</em>
                    </label>
                  </div>
                  <div className="form-conts">
                    <NumericFormat
                      type="text"
                      id="userMblTelno"
                      className="form-control"
                      value={formData.userMblTelno || ''}
                      onChange={handleInputChange}
                      thousandSeparator={false}
                      allowNegative={false}
                      maxLength={11}
                      allowLeadingZeros={true}
                      aria-labelledby="userMblTelno"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label>
                    이메일 주소<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts" style={{ width: '64.4%' }}>
                  <div className="box-sec">
                    <h5 className="box-tit2">
                      <label>{formData.userEml || ''}</label>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <h4 className="gap-md">소속기업 정보</h4>
          <fieldset>
            <legend>소속기업 정보 입력</legend>
            <div className="fieldset">
              <div className="input-group">
                <div className="form-group">
                  <div className="form-title">
                    <label htmlFor="entNm">
                      기업명<em className="star-require">*</em>
                    </label>
                  </div>
                  <div className=" input-group">
                    <input
                      type="text"
                      id="entNm"
                      className="form-control"
                      value={formData.entNm || ''}
                      aria-labelledby="entNm"
                    />
                    <button
                      type="button"
                      className="btn secondary "
                      data-target="search_corp"
                      onClick={() => {
                        openModal();
                      }}
                    >
                      검색
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <div className="input-group">
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="picDept">
                  부서<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <input
                  type="text"
                  id="picDept"
                  onChange={handleInputChange}
                  className="form-control"
                  value={formData.picDept || ''}
                  aria-labelledby="picDept"
                  maxLength={20}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="wrkrRole">
                  직책<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <input
                  type="text"
                  id="wrkrRole"
                  className="form-control"
                  onChange={handleInputChange}
                  value={formData.wrkrRole || ''}
                  aria-labelledby="wrkrRole"
                  maxLength={20}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="page-btn-wrap both">
          <button
            type="button"
            className="btn xlg disband"
            onClick={withDrawal}
          >
            사용자탈퇴
          </button>
          <button
            type="button"
            className="btn xlg primary"
            onClick={beforeUpdate}
          >
            변경내용 저장
          </button>
        </div>
      </div>
      {showModal && (
        <div
          className="modal fade in shown"
          role="dialog"
          aria-labelledby="tit_search_pwd"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog sm">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_search_corp" className="modal-title">
                  기업정보검색
                </h2>
              </div>
              <div className="modal-conts">
                <div className="txt-box search-corp">
                  <fieldset>
                    <legend>기업검색</legend>
                    <div className="form-group">
                      <div className="form-conts">
                        <label className="hidden-label" htmlFor="searchEnt">
                          라벨
                        </label>
                        <select
                          className="form-select"
                          title="선택"
                          id="searchEnt"
                          style={{ width: '50%' }}
                          onChange={handleSearchMethodChange}
                          aria-labelledby="searchEnt"
                        >
                          <option value="entNm">기업명</option>
                          <option value="brno">사업자등록번호</option>
                        </select>
                        <label className="hidden-label" htmlFor="searchValue">
                          라벨
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            id="searchValue"
                            value={searchValue || ''}
                            onChange={() => {
                              setSearchValue(event.target.value);
                            }}
                            className="form-control"
                            placeholder={placeHolderMsg}
                            aria-labelledby="searchValue"
                          />
                          <button
                            type="button"
                            className="btn secondary"
                            onClick={() => {
                              searchEnt();
                            }}
                          >
                            검색
                          </button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {/* 기업정보 테이블 시작*/}
                {entData.length > 0 && (
                  <div className="tbl-wrap">
                    <table className="tbl col data">
                      <caption>
                        기업정보 검색 표로 선택, 사업체명, 사업자등록번호
                        주소등으로 구성되어있음
                      </caption>
                      <colgroup>
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '10%' }} />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">사업체명</th>
                          <th scope="col">사업자등록번호</th>
                          <th scope="col">주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entData.map(entData => (
                          <tr key={entData.entSn}>
                            <th>
                              <button
                                type="button"
                                className="btn primary"
                                onClick={() => {
                                  entSelect(entData.entSn);
                                }}
                              >
                                선택
                              </button>
                            </th>
                            <td>{entData.entNm}</td>
                            <td>{entData.brno}</td>
                            <td>{entData.entAddr}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* 기업정보 테이블 끝*/}
              </div>
              <div className="modal-btn btn-wrap"></div>
              <button
                type="button"
                className="btn-close close-modal"
                onClick={() => {
                  closeModal();
                }}
              >
                <span className="sr-only">닫기</span>
              </button>
            </div>
          </div>
          <div className="modal-back in"></div>
        </div>
      )}
    </>
  );
};

export default UserInfo;
